import { render, staticRenderFns } from "./CandidateDetail.vue?vue&type=template&id=77fb93df&scoped=true"
import script from "./CandidateDetail.vue?vue&type=script&lang=js"
export * from "./CandidateDetail.vue?vue&type=script&lang=js"
import style0 from "./CandidateDetail.vue?vue&type=style&index=0&id=77fb93df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb93df",
  null
  
)

export default component.exports